export default {
  getCalendar: "/attendancecalendar/getcalendarlist",
  setState:"/attendancecalendar/setcalendarlist"
}


// WEBPACK FOOTER //
// ./src/api/config/shift.js